module.exports = __webpack_public_path__ + "static/media/ts1tj44.f80a6c95.png";